import React from "react"
import { Router } from "@reach/router"

import {
  Dashboard,
  Layout,
  ScrollToTop,
  AccountNotApproved,
} from "./components"
import { useAuth } from "./hooks"

export const ProtectedApp = () => {
  const authHook = useAuth()

  return authHook?.accountApproved ? (
    <Layout>
      <Router>
        <ScrollToTop path="*">
          <Dashboard path="/*" />
        </ScrollToTop>
      </Router>
    </Layout>
  ) : (
    <AccountNotApproved />
  )
}
